//form builder

import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Formik, Form, Field } from "formik";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import List from "@material-ui/core/List";
import TextareaAutosize from "react-textarea-autosize";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import edit from "../../assets/images/edit2.svg";
import file from "../../assets/images/file.svg";
import comp1 from "../../assets/images/components/1.svg";
import Eye from "../../assets/images/eye.svg";
import searchsmall from "../../assets/images/Search.svg";
import comp2 from "../../assets/images/components/2.svg";
import comp3 from "../../assets/images/components/3.svg";
import comp4 from "../../assets/images/components/4.svg";
import comp5 from "../../assets/images/components/5.svg";
import comp6 from "../../assets/images/components/6.svg";
import comp7 from "../../assets/images/components/7.svg";
import comp8 from "../../assets/images/components/8.svg";
import comp9 from "../../assets/images/components/9.svg";
import comp10 from "../../assets/images/components/10.svg";
import comp11 from "../../assets/images/secure.svg";
import sdot from "../../assets/images/sdot.svg";
import trash from "../../assets/images/trash.svg";
import copy from "../../assets/images/copy.svg";
import alignLeft from "../../assets/images/align-left.svg";
import close from "../../assets/images/Close.svg";
import upArw from "../../assets/images/upload.svg";
import text from "../../assets/images/text.svg";
import video from "../../assets/images/video.svg";
import image from "../../assets/images/image.svg";
import Spinner from "../../components/Spinner";
import Alert from "../../assets/images/alert-circle.svg";
import center from "../../assets/images/align-center.svg";
import left from "../../assets/images/align-left.svg";
import right from "../../assets/images/align-right.svg";
import closex from "../../assets/images/X.svg";
import imp from "../../assets/images/import.svg";
import "../../assets/css/responsive.css";

const CreateForm = () => {
  const location = useLocation();
  console.log(location);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isTemplete, setIsTemplete] = useState(false);
  const [chatbotId, setChatbotId] = useState(null);
  const [sectionName, setSectionName] = useState("");
  const [sectionSubtitle, setSectionSubtitle] = useState("");
  const [sectionId, setSectionId] = useState(null);
  const [formTitle, setFormTitle] = useState("");
  const [formSubtitle, setFormSubtitle] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [formId, setFormId] = useState(null);
  const [sections, setSections] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [option, setOption] = useState("");
  const [isNewSection, setIsNewSection] = useState(false);
  const [deletedFieldIds, setDeletedFieldIds] = useState([]);
  const [deletedOptionIds, setDeletedOptionIds] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [isDrag, setIsDrag] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const [error, setError] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isTemplate, setIsTemplate] = useState(false);
  const [isTemplateEdit, setIsTemplateEdit] = useState(false);
  const [isTemplateCopy, setIsTemplateCopy] = useState(false);
  const [isSectionTemplateEdit, setIsSectionTemplateEdit] = useState(false);
  const [isSectionTemplateCreate, setIsSectionTemplateCreate] = useState(false);
  const [isSectionTemplateCopy, setIsSectionTemplateCopy] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const [isCandidateEdit, setisCandidateEdit] = useState(false);
  const [templateTitle, setTemplateTitle] = useState("");
  const [templateId, setTemplateId] = useState("");
  const contentState = useRef("");
  const [formData, setFormData] = useState([]);
  const initialValues = formData?.reduce((total, current) => {
    return { ...total, [current.id]: "" };
  }, {});

  //form control elements
  const controls = [
    {
      fieldid: 1,
      value: "heading",
      label: "Heading",
      icon: comp1,
    },
    {
      fieldid: 2,
      value: "paragraph",
      label: "Paragraph",
      icon: comp2,
    },
    {
      fieldid: 3,
      value: "document",
      label: "Document",
      icon: comp3,
    },
    {
      fieldid: 4,
      value: "multiplechoice",
      label: "Multiple Choice",
      icon: comp4,
    },
    {
      fieldid: 5,
      value: "addimage",
      label: "Add Image",
      icon: comp5,
    },
    {
      fieldid: 6,
      value: "addvideo",
      label: "Add Video",
      icon: comp6,
    },
    {
      fieldid: 8,
      value: "textfield",
      label: "Text Field",
      icon: comp8,
    },
    {
      fieldid: 14,
      value: "securefield",
      label: "Secure Field",
      icon: comp11,
    },
    {
      fieldid: 9,
      value: "uploadbutton",
      label: "Upload Button",
      icon: comp9,
    },
    {
      fieldid: 7,
      value: "eSignature",
      label: "eSignature",
      icon: comp7,
    },
  ];

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      width: "45%",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "1px 2px #888888",
    },
  };

  // to keep the right and left elements static while scrolling
  useEffect(() => {
    const main = document.getElementById("main");
    main.addEventListener("scroll", () => {
      const rightDiv = document.getElementById("scrollRightDiv");
      const leftDiv = document.getElementById("scrollLeftDiv");
      if (main.scrollTop > 130) {
        rightDiv.classList.add("componentScroll");
        leftDiv.classList.add("buildLeftDiv");
      } else {
        rightDiv.classList.remove("componentScroll");
        leftDiv.classList.remove("buildLeftDiv");
      }
    });
  }, []);

  //formData setting up according to the page
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("formData"));
    let formTitle = localStorage.getItem("formTitle");
    let formSubtitle = localStorage.getItem("formSubtitle");
    let templateTitle = localStorage.getItem("templateTitle");
    console.log(data);
    // create-form
    if (location.pathname === "/dashboard/onboarding/create-form") {
      setIsTemplateEdit(false);
      setIsEdit(false);
      setisCandidateEdit(false);
      setIsTemplateCopy(false);
      setIsSectionTemplateEdit(false);
      setIsSectionTemplateCreate(false);
      setIsSectionTemplateCopy(false);
      // if (data !== undefined) {
      //   formDataSetUp();
      //   setFormTitle(formTitle !== null ? formTitle : "");
      //   setFormSubtitle(formSubtitle !== null ? formSubtitle : "");
      //   setTemplateTitle(templateTitle !== null ? templateTitle : "");
      // } else
      if (location?.state?.sectionname !== undefined) {
        setIsNewSection(true);
        setSectionName(location?.state?.sectionname);
        setSectionSubtitle(location?.state?.sectionSubtitle);
        let id = localStorage.getItem("ChatbotId");
        setChatbotId(id);
      } else {
        console.log(location?.state?.item?.chatbot_id);
        setChatbotId(location?.state?.item?.chatbot_id);
        setSectionId(location?.state?.item?.id);
        if (
          location?.state?.item?.chatbot_id !== undefined &&
          location?.state?.item?.chatbot_id !== null
        ) {
          fetchSections();
        }
      }
      formDataSetUp();
      // setTemplateTitle(
      //   location?.state === null ? "" : location?.state?.item?.template_name
      // );
      // setFormTitle(
      //   location?.state === null ? "" : location?.state?.item?.title
      // );
      // setFormSubtitle(
      //   location?.state === null ? "" : location?.state?.item?.subtitle
      // );
      fetchTemplates();
      console.log(chatbotId);
    }
    //form edit
    if (location.pathname === "/dashboard/onboarding/edit-form") {
      setIsEdit(true);
      let id = localStorage.getItem("ChatbotId");
      setChatbotId(id);
      setFormId(location?.state?.item?.id);
      setFormTitle(location?.state?.item?.title);
      setFormSubtitle(location?.state?.item?.subtitle);
      formDataSetUp();
      fetchTemplates();
    }
    //edit form for a particular candidate
    if (location.pathname === "/dashboard/onboarding/edit-candidate-form") {
      setisCandidateEdit(true);
      let id = localStorage.getItem("ChatbotId");
      setChatbotId(id);
      setFormId(location?.state?.item?.id);
      setFormTitle(location?.state?.item?.title);
      setFormSubtitle(location?.state?.item?.subtitle);
      formDataSetUp();
      fetchTemplates();
    }
    //edit templates
    if (location.pathname === "/dashboard/onboarding/edit-template") {
      setIsSectionTemplateEdit(false);
      setIsTemplateEdit(true);
      setFormId(location?.state?.item?.id);
      setFormTitle(location?.state?.item?.title);
      setFormSubtitle(location?.state?.item?.subtitle);
      setTemplateTitle(
        location?.state?.item?.template_name !== null
          ? location?.state?.item?.template_name
          : location?.state?.item?.title
      );
      formDataSetUp();
    }
    //copy templates
    if (location.pathname === "/dashboard/onboarding/copy-template") {
      setIsTemplateCopy(true);
      setFormId(location?.state?.item?.id);
      setFormTitle(location?.state?.item?.title);
      setFormSubtitle(location?.state?.item?.subtitle);
      setTemplateTitle("");
      formDataSetUp();
    }
    if (
      location?.pathname ===
      "/dashboard/onboarding/edit-onboarding-template-form"
    ) {
      setIsTemplateEdit(false);
      setIsSectionTemplateEdit(true);
      setFormId(location?.state?.item?.id);
      setFormTitle(location?.state?.item?.title);
      setFormSubtitle(location?.state?.item?.subtitle);
      setTemplateTitle(location?.state?.data?.template_section_name);
      let tempId = localStorage.getItem("tempId");
      setTemplateId(tempId);
      formDataSetUp();
    }
    if (
      location?.pathname ===
      "/dashboard/onboarding/create-onboarding-template-form"
    ) {
      setIsSectionTemplateCreate(true);

      if (location?.state?.sectionname !== undefined) {
        setSectionName(location?.state?.sectionname);
        setSectionSubtitle(location?.state?.sectionSubtitle);
      } else {
        setSectionId(location?.state?.item?.id);
        if (location?.state?.item?.template_id !== undefined) {
          viewTemplate();
        }
      }
      formDataSetUp();
    }
  }, [location]);

  const viewTemplate = async () => {
    setLoader(true);
    let tempData = JSON.parse(localStorage.getItem("Tempdata"));
    const formData = {
      templateid: tempData?.id,
    };
    await ApiHelper.post(API.getTemplateDetails, formData)
      .then((resData) => {
        console.log(resData);
        if (resData.data.success === true) {
          console.log(resData?.data?.templateData[0]);
          setSections(resData?.data?.templateData[0]?.template_data);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  // fetch sections to show them in the dropdown
  const fetchSections = async () => {
    setLoader(true);
    const formData = {
      chatbotid: location?.state?.item?.chatbot_id,
    };
    await ApiHelper.post(API.getSections, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setSections(resData.data.data);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // formData Setup
  const formDataSetUp = () => {
    // debugger;
    let arr = [];
    let array = [];
    let data = JSON.parse(localStorage.getItem("formData"));
    console.log(data, location?.state?.item?.fields);
    if (location?.state?.item?.fields !== undefined) {
      arr = location?.state?.item?.fields;

      console.log(arr);
      for (let i = 0; i < arr?.length; i++) {
        console.log(typeof arr[i].id);
        if (arr[i].field_type_id === 1) {
          let obj = {
            id: i + 1,
            fieldvalue: "heading",
            heading: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired === false
                  ? 0
                  : arr[i].isRequired === true
                  ? 1
                  : arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 2) {
          let obj = {
            id: i + 1,
            fieldvalue: "paragraph",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired === false
                  ? 0
                  : arr[i].isRequired === true
                  ? 1
                  : arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 6) {
          let obj = {
            id: i + 1,
            fieldvalue: "textfield",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 14) {
          let obj = {
            id: i + 1,
            fieldvalue: "securefield",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 11) {
          let obj = {
            id: i + 1,
            fieldvalue: "document",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            documentpath: arr[i].file_path,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 9) {
          let options = [];
          let optionobj = {};
          if (data !== undefined && data !== null) {
            arr[i].options.map((item) => {
              options.push(item);
            });
          } else {
            arr[i].field_options.map((item) => {
              optionobj = {
                option: item.options,
                formfieldoptionid: item.id,
              };
              options.push(optionobj);
            });
          }
          let obj = {
            id: i + 1,
            fieldvalue: "multiplechoice",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            options: options,
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 3) {
          let obj = {
            id: i + 1,
            fieldvalue: "addimage",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            documentpath: arr[i].file_path,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            file_size: arr[i].file_size,
            file_alignment: arr[i].file_alignment,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 4) {
          let obj = {
            id: i + 1,
            fieldvalue: "addvideo",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            documentpath: arr[i].file_path,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 5) {
          let obj = {
            id: i + 1,
            fieldvalue: "eSignature",
            label: arr[i].field_value,
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            showconsent: arr[i].show_consent,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value: arr[i]?.field_value,
          };
          array.push(obj);
        }
        if (arr[i].field_type_id === 7) {
          let obj = {
            id: i + 1,
            fieldvalue: "uploadbutton",
            label: EditorState.createWithContent(
              convertFromRaw(
                data !== undefined && data !== null
                  ? arr[i]?.field_value
                  : JSON.parse(arr[i]?.field_value)
              )
            ),
            formfieldid: typeof arr[i].id === "string" ? "" : arr[i].id,
            isRequired:
              data !== undefined && data !== null
                ? arr[i].isRequired
                : arr[i].is_required,
            field_type_id: arr[i].field_type_id,
            field_value:
              data !== undefined && data !== null
                ? arr[i]?.field_value
                : JSON.parse(arr[i]?.field_value),
          };
          array.push(obj);
        }
      }
    }
    console.log(array);
    setFormData(array);
  };

  //fetch form templates
  const fetchTemplates = async () => {
    setLoader(true);
    let user = JSON.parse(localStorage.getItem("UserData"));
    const formData = {
      userid: user?.id,
      searchkey: searchKey,
    };
    await ApiHelper.post(API.getTemplates, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          setTemplates(resData.data.data);
          setIsOpen(false);
          setLoader(false);
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //delete form templates
  const deleteFormTemplate = async (id) => {
    setLoader(true);
    const formData = {
      templateid: id,
    };
    await ApiHelper.post(API.deleteFormTemplate, formData)
      .then((resData) => {
        if (resData.data.success === true) {
          fetchTemplates();
        }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //search form templates
  useEffect(() => {
    if (searchKey === "") {
      fetchTemplates();
    } else {
      const getData = setTimeout(() => {
        fetchTemplates();
      }, 500);
      return () => {
        clearTimeout(getData);
      };
    }
  }, [searchKey]);

  // update array with deleted component's ids
  const deleteComponent = async (id) => {
    setLoader(true);
    if (id !== undefined) {
      let arr = [...deletedFieldIds];
      arr.push(id);
      setDeletedFieldIds(arr);
    }
    setLoader(false);
  };

  // update array with deleted option's ids
  const deleteOptions = async (id) => {
    setLoader(true);
    if (id !== undefined) {
      let arr = [...deletedOptionIds];
      arr.push(id);
      setDeletedOptionIds(arr);
    }
    setLoader(false);
  };

  //removes copied text styles
  const handlePastedText = (index) => {
    setTimeout(() => {
      console.log(contentState);

      const sanitizedBlocks = contentState.current.blocks.map((item) => {
        return {
          ...item,
          inlineStyleRanges: [], // Remove all inline styles
        };
      });
      console.log(sanitizedBlocks);
      let final = {
        ...contentState.current,
        blocks: sanitizedBlocks,
      };
      console.log(final);
      let editorState = EditorState.createWithContent(convertFromRaw(final));
      let data = [...formData];
      data[index].label = editorState;
      setFormData(data);
    }, 200);
  };

  // handle elements dynamically
  const getControl = (type, id, label, index) => {
    switch (type) {
      case "paragraph":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      {" "}
                      <img src={alignLeft} alt="left" className="align-icon" />
                      Paragraph
                    </h6>
                  </div>

                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);
                        setFormData(data);
                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "paragraph",
                          label: formData[index].label,
                          isRequired: false,
                          field_type_id: 2,
                        });
                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form className="mb-1">
                  <Editor
                    placeholder="Enter description"
                    editorState={formData[index].label}
                    wrapperClassName="demo-wrapper"
                    editorClassName="demo-editor algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "fontSize",
                        "colorPicker",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    handlePastedText={() => {
                      handlePastedText(index);
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].label = e;
                        let contentJSON = convertToRaw(
                          data[index].label.getCurrentContent()
                        );
                        contentState.current = contentJSON;
                        console.log(contentJSON);
                        if (contentJSON?.blocks[0]?.text?.trim() === "") {
                          data[index].isValidate = true;
                        } else {
                          data[index].isValidate = false;
                        }
                        setFormData(data);
                      }
                    }}
                  />
                </form>
              </div>
            </div>
          </section>
        );
      case "heading":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      {" "}
                      <img src={text} alt="left" className="align-icon" />{" "}
                      Heading
                    </h6>
                  </div>
                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);

                        setFormData(data);

                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "heading",
                          heading: formData[index].heading,
                          subheading: EditorState.createEmpty(),
                          isRequired: formData[index].isRequired,
                          field_type_id: 1,
                        });
                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <Editor
                    placeholder="Enter Heading"
                    editorState={formData[index].heading}
                    wrapperClassName="demo-wrapper"
                    editorClassName="inpTxt textArea pl-0 algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].heading = e;
                        let contentJSON = convertToRaw(
                          data[index].heading.getCurrentContent()
                        );
                        console.log(contentJSON);
                        if (contentJSON?.blocks[0]?.text?.trim() === "") {
                          data[index].isValidate = true;
                        } else {
                          data[index].isValidate = false;
                        }
                        setFormData(data);
                      }
                    }}
                  />
                </form>
              </div>
            </div>
          </section>
        );
      case "multiplechoice":
        console.log(formData[index]);
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div
                    className="form-check mx-3 ml-0"
                    style={{ pointerEvents: "none" }}
                  >
                    <input
                      className="form-check-input"
                      type="radio"
                      name="exampleRadios"
                      id="exampleRadios3"
                      value="option01"
                      checked
                    />
                    <label className="form-check-label" for="exampleRadios3">
                      {" "}
                      Multiple Choice
                    </label>
                  </div>
                  <div className="right-align">
                    <div className="reqDiv">
                      <label className="labTog">Required</label>
                      <label class="switch togSw create-toogle">
                        <input
                          type="checkbox"
                          checked={formData[index]?.isRequired === 1}
                          onChange={() => {
                            let data = [...formData];
                            if (data[index]?.isRequired === 1) {
                              data[index].isRequired = 0;
                            } else {
                              data[index].isRequired = 1;
                            }
                            setFormData(data);
                          }}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="iconGrp">
                      <img
                        src={trash}
                        alt="trash"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          data.splice(index, 1);

                          setFormData(data);

                          deleteComponent(formData[index].formfieldid);
                        }}
                      />
                      <img
                        src={copy}
                        alt="copy"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          let opt = [];
                          {
                            formData[index].options?.map((item, i) => {
                              return item?.option !== undefined
                                ? opt.push(item.option)
                                : opt.push(item);
                            });
                          }
                          data.splice(index, 0, {
                            id: `${formData.length}`,
                            fieldvalue: "multiplechoice",
                            label: formData[index].label,
                            options: opt,
                            isRequired: formData[index].isRequired,
                            field_type_id: 9,
                          });
                          setFormData(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <form>
                  <div className="d-flex">
                    <Editor
                      placeholder="Click to write the question text"
                      editorState={formData[index].label}
                      wrapperClassName="demo-wrapper"
                      editorClassName="inpTxt textArea pl-0 newHeight-edit"
                      toolbar={{
                        options: [
                          "inline",
                          "textAlign",
                          "list",
                          "link",
                          "history",
                        ],
                        inline: {
                          options: ["bold", "italic", "underline"],
                        },
                        textAlign: {
                          options: ["left", "center", "justify", "right"],
                        },
                        link: {
                          options: ["link"],
                        },
                        list: {
                          options: ["unordered"],
                        },
                      }}
                      onEditorStateChange={(e) => {
                        if (isDrag === false) {
                          let data = [...formData];
                          data[index].label = e;
                          let contentJSON = convertToRaw(
                            data[index].label.getCurrentContent()
                          );
                          console.log(contentJSON);
                          if (
                            contentJSON?.blocks[0]?.text?.trim() === "" ||
                            data[index]?.options?.length === 0
                          ) {
                            data[index].isValidate = true;
                          } else {
                            data[index].isValidate = false;
                          }
                          setFormData(data);
                        }
                      }}
                    />
                  </div>
                  {formData[index].options?.map((item, i) => {
                    return item?.option !== undefined ? (
                      <div className="d-flex py-2">
                        <div className="form-check inpWid">
                          <input
                            className="form-check-input"
                            type="radio"
                            disabled
                          />
                          <label className="form-check-label" for="write1">
                            {item?.option}
                          </label>
                        </div>
                        <div
                          className="btnWid text-center alginBtn"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={close}
                            alt="close"
                            className="close-icon"
                            onClick={() => {
                              deleteOptions(item?.formfieldoptionid);
                              let data = [...formData];
                              data[index].options.splice(i, 1);

                              setFormData(data);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="d-flex py-2">
                        <div className="form-check inpWid">
                          <input
                            className="form-check-input"
                            type="radio"
                            disabled
                          />
                          <label className="form-check-label" for="write1">
                            {item}
                          </label>
                        </div>
                        <div
                          className="btnWid text-center alginBtn"
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={close}
                            alt="close"
                            className="close-icon"
                            onClick={() => {
                              let data = [...formData];
                              data[index].options.splice(i, 1);
                              let contentJSON = convertToRaw(
                                data[index].label.getCurrentContent()
                              );
                              console.log(contentJSON);
                              if (
                                contentJSON?.blocks[0]?.text?.trim() === "" ||
                                data[index]?.options?.length === 0
                              ) {
                                data[index].isValidate = true;
                              } else {
                                data[index].isValidate = false;
                              }
                              setFormData(data);
                            }}
                          />
                        </div>
                      </div>
                    );
                  })}
                  <input
                    className="form-control mb-2"
                    placeholder="Add Options"
                    onClick={() => {
                      setEditIndex(index);
                    }}
                    value={editIndex === index ? option : ""}
                    onChange={(e) => {
                      setOption(e.target.value);
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" && option.trim() !== "") {
                        event.preventDefault();
                        let optionobj = {};
                        if (isEdit || isTemplateEdit || isSectionTemplateEdit) {
                          optionobj = {
                            option: option,
                            formfieldoptionid: "",
                          };
                          let data = [...formData];
                          data[index].options.push(optionobj);
                          let contentJSON = convertToRaw(
                            data[index].label.getCurrentContent()
                          );
                          console.log(contentJSON);
                          if (
                            contentJSON?.blocks[0]?.text?.trim() === "" ||
                            data[index]?.options?.length === 0
                          ) {
                            data[index].isValidate = true;
                          } else {
                            data[index].isValidate = false;
                          }
                          console.log(data);
                          setFormData(data);
                          setOption("");
                        } else {
                          let data = [...formData];
                          data[index].options.push(option);
                          let contentJSON = convertToRaw(
                            data[index].label.getCurrentContent()
                          );
                          console.log(contentJSON);
                          if (
                            contentJSON?.blocks[0]?.text?.trim() === "" ||
                            data[index]?.options?.length === 0
                          ) {
                            data[index].isValidate = true;
                          } else {
                            data[index].isValidate = false;
                          }
                          setFormData(data);
                          setOption("");
                        }
                      }
                      if (event.key === "Enter" && option.trim() === "") {
                        event.preventDefault();
                      }
                    }}
                  />
                </form>
              </div>
            </div>
          </section>
        );
      case "textfield":
        return (
          <section
            className="formSect txtfComp mb-4"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={comp8} alt="left" className="align-icon" /> Text
                      Field
                    </h6>
                  </div>
                  <div className="right-align">
                    <div className="reqDiv" style={{ marginRight: "25px " }}>
                      <label className="labTog">Required</label>
                      <label class="switch togSw create-toogle">
                        <input
                          type="checkbox"
                          checked={formData[index]?.isRequired === 1}
                          onChange={() => {
                            let data = [...formData];
                            if (data[index]?.isRequired === 1) {
                              data[index].isRequired = 0;
                            } else {
                              data[index].isRequired = 1;
                            }
                            setFormData(data);
                          }}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="iconGrp">
                      <img
                        src={trash}
                        alt="trash"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          data.splice(index, 1);

                          setFormData(data);

                          deleteComponent(formData[index].formfieldid);
                        }}
                      />
                      <img
                        src={copy}
                        alt="copy"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          data.splice(index, 0, {
                            id: `${formData.length}`,
                            fieldvalue: "textfield",
                            label: formData[index].label,
                            isRequired: formData[index].isRequired,
                            field_type_id: 6,
                          });
                          setFormData(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <form>
                  <div className="d-flex">
                    <Editor
                      placeholder="Click to write the question text"
                      editorState={formData[index].label}
                      wrapperClassName="demo-wrapper"
                      editorClassName="inpTxt textArea pl-0"
                      toolbar={{
                        options: [
                          "inline",
                          "textAlign",
                          "list",
                          "link",
                          "history",
                        ],
                        inline: {
                          options: ["bold", "italic", "underline"],
                        },
                        textAlign: {
                          options: ["left", "center", "justify", "right"],
                        },
                        link: {
                          options: ["link"],
                        },
                        list: {
                          options: ["unordered"],
                        },
                      }}
                      onEditorStateChange={(e) => {
                        if (isDrag === false) {
                          let data = [...formData];
                          data[index].label = e;
                          let contentJSON = convertToRaw(
                            data[index].label.getCurrentContent()
                          );
                          console.log(contentJSON);
                          if (contentJSON?.blocks[0]?.text?.trim() === "") {
                            data[index].isValidate = true;
                          } else {
                            data[index].isValidate = false;
                          }
                          setFormData(data);
                        }
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "securefield":
        return (
          <section
            className="formSect txtfComp mb-4"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={comp11} alt="left" className="align-icon" />{" "}
                      Secure Field
                    </h6>
                  </div>
                  <div className="right-align">
                    <div className="reqDiv" style={{ marginRight: "25px " }}>
                      <label className="labTog">Required</label>
                      <label class="switch togSw create-toogle">
                        <input
                          type="checkbox"
                          checked={formData[index]?.isRequired === 1}
                          onChange={() => {
                            let data = [...formData];
                            if (data[index]?.isRequired === 1) {
                              data[index].isRequired = 0;
                            } else {
                              data[index].isRequired = 1;
                            }
                            setFormData(data);
                          }}
                        />
                        <span class="slider round"></span>
                      </label>
                    </div>
                    <div className="iconGrp">
                      <img
                        src={trash}
                        alt="trash"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          data.splice(index, 1);
                          setFormData(data);
                          deleteComponent(formData[index].formfieldid);
                        }}
                      />
                      <img
                        src={copy}
                        alt="copy"
                        className="inp-icon"
                        onClick={() => {
                          let data = [...formData];
                          data.splice(index, 0, {
                            id: `${formData.length}`,
                            fieldvalue: "securefield",
                            label: formData[index].label,
                            isRequired: formData[index].isRequired,
                            field_type_id: 14,
                          });
                          setFormData(data);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <form>
                  <div className="d-flex">
                    <Editor
                      placeholder="Click to write the question text"
                      editorState={formData[index].label}
                      wrapperClassName="demo-wrapper"
                      editorClassName="inpTxt textArea pl-0"
                      toolbar={{
                        options: [
                          "inline",
                          "textAlign",
                          "list",
                          "link",
                          "history",
                        ],
                        inline: {
                          options: ["bold", "italic", "underline"],
                        },
                        textAlign: {
                          options: ["left", "center", "justify", "right"],
                        },
                        link: {
                          options: ["link"],
                        },
                        list: {
                          options: ["unordered"],
                        },
                      }}
                      onEditorStateChange={(e) => {
                        if (isDrag === false) {
                          let data = [...formData];
                          data[index].label = e;
                          let contentJSON = convertToRaw(
                            data[index].label.getCurrentContent()
                          );
                          console.log(contentJSON);
                          if (contentJSON?.blocks[0]?.text?.trim() === "") {
                            data[index].isValidate = true;
                          } else {
                            data[index].isValidate = false;
                          }
                          setFormData(data);
                        }
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "addimage":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={image} alt="left" className="align-icon" />{" "}
                      Image
                    </h6>
                  </div>
                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);
                        setFormData(data);
                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "addimage",
                          label: formData[index].label,
                          documentpath: formData[index].documentpath,
                          isRequired: formData[index].isRequired,
                          file_size: formData[index].file_size,
                          file_alignment: formData[index].file_alignment,
                          field_type_id: 3,
                        });
                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <Editor
                    placeholder="Enter Text"
                    editorState={formData[index].label}
                    wrapperClassName="demo-wrapper"
                    editorClassName="inpTxt textArea pl-0 algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].label = e;
                        setFormData(data);
                      }
                    }}
                  />
                  {formData[index].documentpath !== "" && (
                    <div className="wraper">
                      <div className="img-alignWraper mb-2">
                        <div className="aligWrap">
                          <div
                            className="btnWid btn-group aligmt-icon-divx"
                            onClick={(e) => {
                              e.preventDefault();
                              let data = [...formData];
                              data[index].file_alignment = "left";
                              setFormData(data);
                            }}
                          >
                            <button
                              type="button m-0"
                              className={
                                formData[index].file_alignment === "left"
                                  ? "aligmt-icon active"
                                  : "aligmt-icon"
                              }
                            >
                              <img
                                src={left}
                                alt="test"
                                className="aligmt-img"
                              />
                            </button>
                          </div>
                          <div
                            className="btnWid btn-group aligmt-icon-divx"
                            onClick={(e) => {
                              e.preventDefault();
                              let data = [...formData];
                              setFormData(data);
                            }}
                          >
                            <button
                              type="button m-0"
                              className={
                                formData[index].file_alignment === "center"
                                  ? "aligmt-icon active"
                                  : "aligmt-icon"
                              }
                            >
                              <img
                                src={center}
                                alt="test"
                                className="aligmt-img"
                              />
                            </button>
                          </div>
                          <div
                            className="btnWid  btn-group aligmt-icon-divx "
                            onClick={(e) => {
                              e.preventDefault();
                              let data = [...formData];
                              data[index].file_alignment = "right";
                              setFormData(data);
                            }}
                          >
                            <button
                              type="button m-0"
                              className={
                                formData[index].file_alignment === "right"
                                  ? "aligmt-icon active"
                                  : "aligmt-icon"
                              }
                            >
                              <img
                                src={right}
                                alt="test"
                                className="aligmt-img"
                              />
                            </button>
                          </div>
                        </div>
                        <div className="aligDiv imagesize-divs">
                          <label className="image-name">Image size:</label>
                          <select
                            className="image-size "
                            value={formData[index]?.file_size}
                            onChange={(e) => {
                              let data = [...formData];
                              data[index].file_size = e.target.value;
                              setFormData(data);
                            }}
                          >
                            <option value="small">Small</option>
                            <option value="medium">Medium</option>
                            <option value="large">Large</option>
                          </select>
                        </div>
                      </div>
                      <div className="img-wraper">
                        <img
                          src={API.mediaView + formData[index].documentpath}
                          className="mb-1"
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="d-flex my-2 wraper">
                    <div className="inpWid alignImg-inpts">
                      <div className="inptFiles_up d-flex">
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            onMediaChange(index, e);
                          }}
                        />
                        <button type="button" className="upBtn">
                          Upload
                        </button>
                        <p>
                          {formData[index].documentpath === ""
                            ? "No file chosen"
                            : formData[index].documentpath?.split("_").pop()}
                        </p>
                      </div>
                    </div>
                    {formData[index].documentpath !== "" && (
                      <div className="btnWid text-center alginBtn alginBtn">
                        <img
                          src={close}
                          alt="close"
                          className="close-icon"
                          onClick={() => {
                            let data = [...formData];
                            data[index].documentpath = "";

                            setFormData(data);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "addvideo":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={video} alt="left" className="align-icon" />{" "}
                      video
                    </h6>
                  </div>

                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);
                        setFormData(data);
                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "addvideo",
                          label: formData[index].label,
                          documentpath: formData[index].documentpath,
                          isRequired: formData[index].isRequired,
                          field_type_id: 4,
                        });
                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <Editor
                    placeholder="Enter Text"
                    editorState={formData[index].label}
                    wrapperClassName="demo-wrapper"
                    editorClassName="inpTxt textArea pl-0 algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].label = e;

                        setFormData(data);
                      }
                    }}
                  />
                  {formData[index].documentpath !== "" && (
                    <video
                      src={API.mediaView + formData[index].documentpath}
                      className="mb-1"
                      style={{ height: 300, width: 600 }}
                      controls
                    />
                  )}
                  <div className="d-flex py-2">
                    <div className="inpWid">
                      <div className="inptFiles_up d-flex">
                        <input
                          type="file"
                          accept="video/*"
                          onChange={(e) => {
                            onMediaChange(index, e);
                          }}
                        />
                        <button type="button" className="upBtn">
                          Upload
                        </button>
                        <p>
                          {formData[index].documentpath === ""
                            ? "No file chosen"
                            : formData[index].documentpath?.split("_").pop()}
                        </p>
                      </div>
                    </div>
                    {formData[index].documentpath !== "" && (
                      <div className="btnWid text-center alginBtn alginBtn">
                        <img
                          src={close}
                          alt="close"
                          className="close-icon"
                          onClick={() => {
                            let data = [...formData];
                            data[index].documentpath = "";

                            setFormData(data);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "eSignature":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={edit} alt="left" className="align-icon" />{" "}
                      eSignature
                    </h6>
                  </div>
                  <div className="reqDiv " style={{ marginRight: "25px" }}>
                    <label className="labTog">Required</label>
                    <label class="switch togSw create-toogle">
                      <input
                        type="checkbox"
                        checked={formData[index]?.isRequired === 1}
                        onChange={() => {
                          let data = [...formData];
                          if (data[index]?.isRequired === 1) {
                            data[index].isRequired = 0;
                          } else {
                            data[index].isRequired = 1;
                          }

                          setFormData(data);
                        }}
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>

                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);

                        setFormData(data);

                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon copyicon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "eSignature",
                          label: formData[index].label,
                          showconsent: formData[index].showconsent,
                          isRequired: formData[index].isRequired,

                          field_type_id: 5,
                        });

                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <div className="d-flex aligChx aligEsig">
                    <input
                      className="form-check-input pl-0"
                      type="checkbox"
                      checked={false}
                      onChange={(e) => {
                        let data = [...formData];
                        if (formData[index].showconsent === 1)
                          data[index].showconsent = 0;
                        else data[index].showconsent = 1;
                        setFormData(data);
                      }}
                    />

                    <TextareaAutosize
                      className="inpTxt textArea pl-0 pt-0 pb-1"
                      placeholder="Enter Consent Message"
                      value={formData[index].label}
                      onChange={(e) => {
                        let data = [...formData];
                        data[index].label = e.target.value;
                        if (data[index].label === "") {
                          data[index].isValidate = true;
                        } else {
                          data[index].isValidate = false;
                        }
                        setFormData(data);
                      }}
                    />
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "document":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={file} alt="left" className="align-icon" />{" "}
                      Document
                    </h6>
                  </div>
                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);

                        setFormData(data);

                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "document",
                          label: formData[index].label,
                          documentpath: formData[index].documentpath,
                          isRequired: formData[index].isRequired,
                          field_type_id: 11,
                        });

                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <Editor
                    placeholder="Enter Text"
                    editorState={formData[index].label}
                    wrapperClassName="demo-wrapper"
                    editorClassName="inpTxt textArea pl-0 algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].label = e;

                        setFormData(data);
                      }
                    }}
                  />
                  <div className="d-flex py-2">
                    <div className="inpWid">
                      <div className="inptFiles_up d-flex">
                        <input
                          type="file"
                          accept=".xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf"
                          onChange={(e) => {
                            onMediaChange(index, e);
                          }}
                        />
                        <button type="button" className="upBtn">
                          Upload
                        </button>
                        <p>
                          {formData[index].documentpath === ""
                            ? "No file chosen"
                            : formData[index].documentpath?.split("_").pop()}
                        </p>
                      </div>
                    </div>
                    {formData[index].documentpath !== "" && (
                      <div className="btnWid text-center alginBtn alginBtn">
                        <img
                          src={close}
                          alt="close"
                          className="close-icon"
                          onClick={() => {
                            let data = [...formData];
                            data[index].documentpath = "";

                            setFormData(data);
                          }}
                        />
                      </div>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </section>
        );
      case "uploadbutton":
        return (
          <section
            className="formSect mb-3"
            style={{
              border:
                formData[index]?.isValidate === true ? "1px solid red" : null,
            }}
          >
            <div className="alinBx">
              <div className="LeftCont">
                <button className="btn">
                  <img src={sdot} alt="test" className="menu_icon" />
                </button>
              </div>
              <div className="RightCont">
                <div className="topSect pt-2">
                  <div className="wraper">
                    <h6>
                      <img src={upArw} alt="left" className="align-icon" />{" "}
                      Upload Button
                    </h6>
                  </div>
                  <div className="reqDiv">
                    <label className="labTog">Required</label>
                    <label class="switch togSw create-toogle">
                      <input
                        type="checkbox"
                        checked={formData[index]?.isRequired === 1}
                        onChange={() => {
                          let data = [...formData];
                          if (data[index]?.isRequired === 1) {
                            data[index].isRequired = 0;
                          } else {
                            data[index].isRequired = 1;
                          }

                          setFormData(data);
                        }}
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>

                  <div className="iconGrp">
                    <img
                      src={trash}
                      alt="trash"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 1);

                        setFormData(data);

                        deleteComponent(formData[index].formfieldid);
                      }}
                    />
                    <img
                      src={copy}
                      alt="copy"
                      className="inp-icon"
                      onClick={() => {
                        let data = [...formData];
                        data.splice(index, 0, {
                          id: `${formData.length}`,
                          fieldvalue: "uploadbutton",
                          label: formData[index].label,
                          isRequired: formData[index].isRequired,
                          field_type_id: 7,
                        });

                        setFormData(data);
                      }}
                    />
                  </div>
                </div>
                <hr />
                <form>
                  <Editor
                    placeholder="Enter Text"
                    editorState={formData[index].label}
                    wrapperClassName="demo-wrapper"
                    editorClassName="inpTxt textArea pl-0 algLabel"
                    toolbar={{
                      options: [
                        "inline",
                        "textAlign",
                        "list",
                        "link",
                        "history",
                      ],
                      inline: {
                        options: ["bold", "italic", "underline"],
                      },
                      textAlign: {
                        options: ["left", "center", "justify", "right"],
                      },
                      link: {
                        options: ["link"],
                      },
                      list: {
                        options: ["unordered"],
                      },
                    }}
                    onEditorStateChange={(e) => {
                      if (isDrag === false) {
                        let data = [...formData];
                        data[index].label = e;
                        let contentJSON = convertToRaw(
                          data[index].label.getCurrentContent()
                        );
                        console.log(contentJSON);
                        if (contentJSON?.blocks[0]?.text?.trim() === "") {
                          data[index].isValidate = true;
                        } else {
                          data[index].isValidate = false;
                        }
                        setFormData(data);
                      }
                    }}
                  />
                </form>
              </div>
            </div>
          </section>
        );
      default:
        return <div>{type}</div>;
    }
  };

  //upload files
  const onMediaChange = async (index, e) => {
    console.log(e?.target?.files[0]);
    const maxSizeInBytes = 8 * 1024 * 1024; // 8MB
    if (e?.target?.files[0]?.size > maxSizeInBytes) {
      toast("File size too large!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setLoader(true);
      let form = new FormData();
      form.append("chatbotid", chatbotId === undefined ? 1000 : chatbotId);
      form.append("onboarding_media_files", e.target.files[0]);
      await ApiHelper.mediapost(API.uploadMedia, form)
        .then((resData) => {
          if (resData?.data?.success === true) {
            let data = [...formData];
            data[index].documentpath = resData.data?.filepath;
            if (data[index].documentpath === "") {
              data[index].isValidate = true;
            } else {
              data[index].isValidate = false;
            }
            setFormData(data);
            setLoader(false);
          } else {
            toast(resData?.data?.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  //preview form
  const preview = () => {
    // let forms = [...formData];
    // console.log(forms, isEdit);
    // for (let i = 0; i < formData.length; i++) {
    //   if (forms[i].fieldvalue === "heading") {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].heading.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //   } else if (forms[i].fieldvalue === "eSignature") {
    //     forms[i].field_value = formData[i].label;
    //   } else if (forms[i].fieldvalue === "secureField") {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].label.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //     forms[i].isVisible = false;
    //   } else if (forms[i].fieldvalue === "addimage") {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].label.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //     forms[i].file_size = formData[i].file_size;
    //     forms[i].file_alignment = formData[i].file_alignment;
    //     forms[i].file_path = formData[i].documentpath;
    //   } else if (forms[i].fieldvalue === "addvideo") {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].label.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //     forms[i].file_path = formData[i].documentpath;
    //   } else if (forms[i].fieldvalue === "document") {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].label.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //     forms[i].file_path = formData[i].documentpath;
    //   } else {
    //     forms[i].field_value = convertToRaw(
    //       !isEdit
    //         ? formData[i].label.getCurrentContent()
    //         : formData[i].field_value
    //     );
    //   }
    // }
    // console.log(forms);
    // navigate("/preview", {
    //   state: {
    //     formData: JSON.stringify(forms),
    //     title: formTitle,
    //     subtitle: formSubtitle,
    //   },
    // });
    // localStorage.setItem("formData", JSON.stringify(forms));
    // localStorage.setItem("formTitle", formTitle);
    // localStorage.setItem("formSubtitle", formSubtitle);
    // localStorage.setItem("templateTitle", templateTitle);

    if (
      location.pathname === "/dashboard/onboarding/create-form" &&
      (chatbotId === undefined || chatbotId == null)
    ) {
      let flag = false;
      if (formTitle.trim() === "" || templateTitle.trim() === "") {
        setError(true);
      } else {
        setError(false);
        console.log(formData);
        let data = [...formData];
        for (let i = 0; i < formData.length; i++) {
          if (formData[i].fieldvalue === "heading") {
            let contentJSON = convertToRaw(
              formData[i].heading.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "paragraph") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "textfield") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "securefield") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "multiplechoice") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (
              contentJSON?.blocks[0]?.text?.trim() === "" ||
              formData[i]?.options?.length === 0
            ) {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "document") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "addimage") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "addvideo") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "eSignature") {
            if (formData[i].label === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "uploadbutton") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          console.log(error);
        }
        console.log(data);
        setFormData(data);
        setTimeout(async () => {
          const form = [];
          if (flag === false) {
            setLoader(true);
            for (let i = 0; i < formData.length; i++) {
              if (formData[i].fieldvalue === "heading")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 1,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].heading.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "paragraph")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 2,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "document")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 11,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                });
              if (formData[i].fieldvalue === "multiplechoice")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 9,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  options: formData[i].options,
                });
              if (formData[i].fieldvalue === "textfield")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 6,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "securefield")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 14,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "addimage")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 3,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                  file_size: formData[i].file_size,
                  file_alignment: formData[i].file_alignment,
                });
              if (formData[i].fieldvalue === "addvideo")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 4,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                });
              if (formData[i].fieldvalue === "eSignature")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 5,
                  fieldvalue: formData[i].label,
                  showconsent: formData[i].showconsent,
                });
              if (formData[i].fieldvalue === "uploadbutton")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 7,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
            }
            let obj = {};
            let user = JSON.parse(localStorage.getItem("UserData"));
            obj = {
              userid: user?.id,
              title: formTitle,
              template_name: templateTitle,
              ispublic: 0,
              subtitle: formSubtitle,
              components: form,
            };
            await ApiHelper.post(API.createTemplate, obj)
              .then((resData) => {
                if (resData?.data?.success === true) {
                  // setFormData([]);
                  // setFormTitle("");
                  // setFormSubtitle("");
                  // setTemplateTitle("");
                  // fetchTemplates();
                  // toast("Form added successfully!", {
                  //   position: "top-right",
                  //   autoClose: 5000,
                  //   hideProgressBar: true,
                  //   closeOnClick: true,
                  //   pauseOnHover: true,
                  //   draggable: true,
                  //   progress: undefined,
                  //   theme: "light",
                  // });
                  localStorage.setItem("prevRoute", "createTemplate");
                  navigate("/preview", {
                    state: { tempId: resData?.data?.template_id },
                  });
                  setLoader(false);
                } else {
                  toast(resData?.data?.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setLoader(false);
                }
              })
              .catch((err) => {
                setLoader(false);
                console.log(err);
              });
          }
        }, 1000);
      }
    } else {
      let flag = false;
      if (
        (isTemplateEdit || isTemplateCopy) &&
        (templateTitle === "" || templateTitle === null)
      ) {
        setError(true);
      } else {
        if (formTitle.trim() === "" || formTitle === null) {
          setError(true);
        } else {
          setError(false);
          let data = [...formData];
          for (let i = 0; i < formData.length; i++) {
            if (formData[i].fieldvalue === "heading") {
              let contentJSON = convertToRaw(
                formData[i].heading.getCurrentContent()
              );
              console.log(contentJSON);
              if (contentJSON?.blocks[0]?.text?.trim() === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }

            if (formData[i].fieldvalue === "paragraph") {
              let contentJSON = convertToRaw(
                formData[i].label.getCurrentContent()
              );
              console.log(contentJSON);
              if (contentJSON?.blocks[0]?.text?.trim() === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "textfield") {
              let contentJSON = convertToRaw(
                formData[i].label.getCurrentContent()
              );
              console.log(contentJSON);
              if (contentJSON?.blocks[0]?.text?.trim() === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "securefield") {
              let contentJSON = convertToRaw(
                formData[i].label.getCurrentContent()
              );
              console.log(contentJSON);
              if (contentJSON?.blocks[0]?.text?.trim() === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "multiplechoice") {
              let contentJSON = convertToRaw(
                formData[i].label.getCurrentContent()
              );
              console.log(contentJSON);
              if (
                contentJSON?.blocks[0]?.text?.trim() === "" ||
                formData[i]?.options?.length === 0
              ) {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "document") {
              if (formData[i].documentpath === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "addimage") {
              if (formData[i].documentpath === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "addvideo") {
              if (formData[i].documentpath === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "eSignature") {
              if (formData[i].label === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
            if (formData[i].fieldvalue === "uploadbutton") {
              let contentJSON = convertToRaw(
                formData[i].label.getCurrentContent()
              );
              console.log(contentJSON);
              if (contentJSON?.blocks[0]?.text?.trim() === "") {
                data[i].isValidate = true;
                flag = true;
              } else {
                data[i].isValidate = false;
              }
            }
          }
          setFormData(data);
          setTimeout(async () => {
            if (flag === false) {
              // setLoader(true)
              const form = [];
              const forms = [];
              for (let i = 0; i < formData.length; i++) {
                if (formData[i].fieldvalue === "heading")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 1,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].heading.getCurrentContent())
                    ),
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "paragraph")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 2,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "document")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 11,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "multiplechoice")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 9,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    options: formData[i].options,
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "textfield")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 6,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "securefield")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 14,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "addimage")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 3,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                    file_size: formData[i].file_size,
                    file_alignment: formData[i].file_alignment,
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "addvideo")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 4,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "eSignature")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 5,
                    fieldvalue: formData[i].label,
                    showconsent: 0,
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
                if (formData[i].fieldvalue === "uploadbutton")
                  forms.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 7,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    formfieldid:
                      formData[i].formfieldid === undefined
                        ? ""
                        : formData[i].formfieldid,
                  });
              }
              for (let i = 0; i < formData.length; i++) {
                if (formData[i].fieldvalue === "heading")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 1,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].heading.getCurrentContent())
                    ),
                  });
                if (formData[i].fieldvalue === "paragraph")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 2,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                  });
                if (formData[i].fieldvalue === "document")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 11,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                  });
                if (formData[i].fieldvalue === "multiplechoice")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 9,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    options: formData[i].options,
                  });
                if (formData[i].fieldvalue === "textfield")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 6,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                  });
                if (formData[i].fieldvalue === "securefield")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 14,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                  });
                if (formData[i].fieldvalue === "addimage")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 3,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                    file_size: formData[i].file_size,
                    file_alignment: formData[i].file_alignment,
                  });
                if (formData[i].fieldvalue === "addvideo")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 4,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                    filepath: formData[i].documentpath,
                  });
                if (formData[i].fieldvalue === "eSignature")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 5,
                    fieldvalue: formData[i].label,
                    showconsent: 0,
                  });
                if (formData[i].fieldvalue === "uploadbutton")
                  form.push({
                    isrequired: formData[i]?.isRequired,
                    fieldid: 7,
                    fieldvalue: JSON.stringify(
                      convertToRaw(formData[i].label.getCurrentContent())
                    ),
                  });
              }
              let obj = {};
              if (isNewSection) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  chatbotid: chatbotId,
                  userid: user?.id,
                  ispublic: 0,
                  sectionname: sectionName,
                  sectionsubtitle: sectionSubtitle,
                  title: formTitle,
                  subtitle: formSubtitle,
                  maketemplate: isTemplete,
                  components: form,
                };
              } else {
                if (isEdit) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    formid: formId,
                    userid: user?.id,
                    chatbotid: chatbotId,
                    ispublic: 0,
                    title: formTitle,
                    subtitle: formSubtitle,
                    maketemplate: isTemplete,
                    deletedfieldids: deletedFieldIds,
                    deletedoptionids: deletedOptionIds,
                    components: forms,
                  };
                } else if (isCandidateEdit) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    formid: formId,
                    userid: user?.id,
                    chatbotid: chatbotId,
                    ispublic: 0,
                    title: formTitle,
                    subtitle: formSubtitle,
                    deletedfieldids: deletedFieldIds,
                    deletedoptionids: deletedOptionIds,
                    components: forms,
                  };
                } else if (isTemplateEdit) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    formid: formId,
                    userid: user?.id,
                    // ispublic: 0,
                    edit_template_type: "form",
                    template_name: templateTitle,
                    title: formTitle,
                    subtitle: formSubtitle,
                    deletedfieldids: deletedFieldIds,
                    deletedoptionids: deletedOptionIds,
                    components: forms,
                  };
                } else if (isTemplateCopy) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    userid: user?.id,
                    // ispublic: 0,
                    template_name: templateTitle,
                    title: formTitle,
                    subtitle: formSubtitle,
                    components: forms,
                  };
                } else if (isSectionTemplateEdit) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    userid: user?.id,
                    template_id: templateId,
                    formid: formId,
                    edit_template_type: "section",
                    title: formTitle,
                    maketemplate: isTemplete,
                    subtitle: formSubtitle,
                    components: forms,
                    deletedfieldids: deletedFieldIds,
                    deletedoptionids: deletedOptionIds,
                  };
                } else if (isSectionTemplateCreate) {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  let tempData = JSON.parse(localStorage.getItem("Tempdata"));
                  if (location?.state?.sectionname !== undefined) {
                    obj = {
                      templateid: tempData?.id,
                      userid: user?.id,
                      ispublic: 0,
                      sectionname: sectionName,
                      sectionsubtitle: sectionSubtitle,
                      title: formTitle,
                      subtitle: formSubtitle,
                      maketemplate: isTemplete,
                      components: form,
                    };
                  } else {
                    obj = {
                      templateid: tempData?.id,
                      userid: user?.id,
                      sectionid: sectionId,
                      title: formTitle,
                      subtitle: formSubtitle,
                      maketemplate: isTemplete,
                      components: form,
                    };
                  }
                } else {
                  let user = JSON.parse(localStorage.getItem("UserData"));
                  obj = {
                    chatbotid: chatbotId,
                    userid: user?.id,
                    sectionid: sectionId,
                    title: formTitle,
                    subtitle: formSubtitle,
                    maketemplate: isTemplete,
                    components: form,
                  };
                }
              }
              console.log(obj);
              await ApiHelper.post(
                isEdit
                  ? API.editForm
                  : isCandidateEdit
                  ? API.editCandidateForm
                  : isTemplateEdit
                  ? API.editTemplate
                  : isTemplateCopy
                  ? API.copyTemplate
                  : isSectionTemplateEdit
                  ? API.editTemplate
                  : isSectionTemplateCreate
                  ? API.createTempForm
                  : API.createForm,
                obj
              )
                .then((resData) => {
                  console.log("CreateForm", resData);
                  // debugger;
                  if (resData?.data?.success === false) {
                    toast(resData?.data?.message, {
                      position: "top-right",
                      autoClose: 5000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                    setLoader(false);
                  } else if (
                    isCandidateEdit &&
                    resData?.data?.success === true
                  ) {
                    navigate("/dashboard/candidates");
                    setLoader(false);
                  } else if (
                    isSectionTemplateEdit &&
                    resData?.data?.success === true
                  ) {
                    localStorage.setItem("prevRoute", "sectionTemplateEdit");
                    // navigate("/dashboard/onboarding/edit-onboarding-template");
                    navigate("/preview", {
                      state: { formid: formId },
                    });
                    setLoader(false);
                  } else if (
                    isSectionTemplateCreate &&
                    resData?.data?.success === true
                  ) {
                    localStorage.setItem("prevRoute", "sectionTemplateEdit");
                    // navigate("/dashboard/onboarding/templates");
                    navigate("/preview", {
                      state: { formid: resData?.data?.formid },
                    });
                    setLoader(false);
                  } else if (
                    (isTemplateEdit || isTemplateCopy) &&
                    resData?.data?.success === true
                  ) {
                    localStorage.setItem("prevRoute", "templateEdit");
                    navigate("/preview", {
                      state: { formTempId: formId },
                    });
                    setLoader(false);
                  } else {
                    if (!isEdit && resData?.data?.success === true) {
                      localStorage.setItem("prevRoute", "createForm");
                      navigate("/preview", {
                        state: { formId: resData?.data?.formId },
                      });
                      setLoader(false);
                    }
                    if (isEdit && resData?.data?.success === true) {
                      localStorage.setItem("prevRoute", "isFormEdit");
                      // navigate("/dashboard/onboarding/edit-forms");
                      navigate("/preview", {
                        state: { formId: formId },
                      });
                      setLoader(false);
                    }
                  }
                })
                .catch((err) => {
                  setLoader(false);
                  console.log(err);
                });
            }
          }, 1000);
        }
      }
    }
  };

  //create templates
  const createTemplate = async () => {
    let flag = false;
    if (formTitle.trim() === "" || templateTitle.trim() === "") {
      setError(true);
    } else {
      setError(false);
      console.log(formData);
      let data = [...formData];
      for (let i = 0; i < formData.length; i++) {
        if (formData[i].fieldvalue === "heading") {
          let contentJSON = convertToRaw(
            formData[i].heading.getCurrentContent()
          );
          console.log(contentJSON);
          if (contentJSON?.blocks[0]?.text?.trim() === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "paragraph") {
          let contentJSON = convertToRaw(formData[i].label.getCurrentContent());
          console.log(contentJSON);
          if (contentJSON?.blocks[0]?.text?.trim() === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "textfield") {
          let contentJSON = convertToRaw(formData[i].label.getCurrentContent());
          console.log(contentJSON);
          if (contentJSON?.blocks[0]?.text?.trim() === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "securefield") {
          let contentJSON = convertToRaw(formData[i].label.getCurrentContent());
          console.log(contentJSON);
          if (contentJSON?.blocks[0]?.text?.trim() === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "multiplechoice") {
          let contentJSON = convertToRaw(formData[i].label.getCurrentContent());
          console.log(contentJSON);
          if (
            contentJSON?.blocks[0]?.text?.trim() === "" ||
            formData[i]?.options?.length === 0
          ) {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "document") {
          if (formData[i].documentpath === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "addimage") {
          if (formData[i].documentpath === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "addvideo") {
          if (formData[i].documentpath === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "eSignature") {
          if (formData[i].label === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        if (formData[i].fieldvalue === "uploadbutton") {
          let contentJSON = convertToRaw(formData[i].label.getCurrentContent());
          console.log(contentJSON);
          if (contentJSON?.blocks[0]?.text?.trim() === "") {
            data[i].isValidate = true;
            flag = true;
          } else {
            data[i].isValidate = false;
          }
        }
        console.log(error);
      }
      console.log(data);
      setFormData(data);
      setTimeout(async () => {
        const form = [];
        if (flag === false) {
          setLoader(true);
          for (let i = 0; i < formData.length; i++) {
            if (formData[i].fieldvalue === "heading")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 1,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].heading.getCurrentContent())
                ),
              });
            if (formData[i].fieldvalue === "paragraph")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 2,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
              });
            if (formData[i].fieldvalue === "document")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 11,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
                filepath: formData[i].documentpath,
              });
            if (formData[i].fieldvalue === "multiplechoice")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 9,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
                options: formData[i].options,
              });
            if (formData[i].fieldvalue === "textfield")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 6,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
              });
            if (formData[i].fieldvalue === "securefield")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 14,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
              });
            if (formData[i].fieldvalue === "addimage")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 3,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
                filepath: formData[i].documentpath,
                file_size: formData[i].file_size,
                file_alignment: formData[i].file_alignment,
              });
            if (formData[i].fieldvalue === "addvideo")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 4,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
                filepath: formData[i].documentpath,
              });
            if (formData[i].fieldvalue === "eSignature")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 5,
                fieldvalue: formData[i].label,
                showconsent: formData[i].showconsent,
              });
            if (formData[i].fieldvalue === "uploadbutton")
              form.push({
                isrequired: formData[i]?.isRequired,
                fieldid: 7,
                fieldvalue: JSON.stringify(
                  convertToRaw(formData[i].label.getCurrentContent())
                ),
              });
          }
          let obj = {};
          let user = JSON.parse(localStorage.getItem("UserData"));
          obj = {
            userid: user?.id,
            title: formTitle,
            template_name: templateTitle,
            ispublic: 0,
            subtitle: formSubtitle,
            components: form,
          };
          await ApiHelper.post(API.createTemplate, obj)
            .then((resData) => {
              if (resData?.data?.success === true) {
                setFormData([]);
                setFormTitle("");
                setFormSubtitle("");
                setTemplateTitle("");
                fetchTemplates();
                toast("Form added successfully!", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                navigate("/dashboard/onboarding/templates");
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        }
      }, 1000);
    }
  };

  //handles save button
  const handleSubmit = async () => {
    debugger;
    console.log(formTitle);
    let flag = false;
    if (
      (isTemplateEdit || isTemplateCopy) &&
      (templateTitle === "" || templateTitle === null)
    ) {
      setError(true);
    } else {
      if (formTitle?.trim() === "" || formTitle === null) {
        setError(true);
      } else {
        setError(false);
        let data = [...formData];
        for (let i = 0; i < formData.length; i++) {
          if (formData[i].fieldvalue === "heading") {
            let contentJSON = convertToRaw(
              formData[i].heading.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }

          if (formData[i].fieldvalue === "paragraph") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "textfield") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "securefield") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "multiplechoice") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (
              contentJSON?.blocks[0]?.text?.trim() === "" ||
              formData[i]?.options?.length === 0
            ) {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "document") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "addimage") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "addvideo") {
            if (formData[i].documentpath === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "eSignature") {
            if (formData[i].label === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
          if (formData[i].fieldvalue === "uploadbutton") {
            let contentJSON = convertToRaw(
              formData[i].label.getCurrentContent()
            );
            console.log(contentJSON);
            if (contentJSON?.blocks[0]?.text?.trim() === "") {
              data[i].isValidate = true;
              flag = true;
            } else {
              data[i].isValidate = false;
            }
          }
        }
        setFormData(data);
        setTimeout(async () => {
          if (flag === false) {
            // setLoader(true)
            const form = [];
            const forms = [];
            for (let i = 0; i < formData.length; i++) {
              if (formData[i].fieldvalue === "heading")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 1,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].heading.getCurrentContent())
                  ),
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "paragraph")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 2,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "document")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 11,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "multiplechoice")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 9,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  options: formData[i].options,
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "textfield")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 6,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "securefield")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 14,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "addimage")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 3,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                  file_size: formData[i].file_size,
                  file_alignment: formData[i].file_alignment,
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "addvideo")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 4,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "eSignature")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 5,
                  fieldvalue: formData[i].label,
                  showconsent: 0,
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
              if (formData[i].fieldvalue === "uploadbutton")
                forms.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 7,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  formfieldid:
                    formData[i].formfieldid === undefined
                      ? ""
                      : formData[i].formfieldid,
                });
            }
            for (let i = 0; i < formData.length; i++) {
              if (formData[i].fieldvalue === "heading")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 1,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].heading.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "paragraph")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 2,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "document")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 11,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                });
              if (formData[i].fieldvalue === "multiplechoice")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 9,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  options: formData[i].options,
                });
              if (formData[i].fieldvalue === "textfield")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 6,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "securefield")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 14,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
              if (formData[i].fieldvalue === "addimage")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 3,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                  file_size: formData[i].file_size,
                  file_alignment: formData[i].file_alignment,
                });
              if (formData[i].fieldvalue === "addvideo")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 4,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                  filepath: formData[i].documentpath,
                });
              if (formData[i].fieldvalue === "eSignature")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 5,
                  fieldvalue: formData[i].label,
                  showconsent: 0,
                });
              if (formData[i].fieldvalue === "uploadbutton")
                form.push({
                  isrequired: formData[i]?.isRequired,
                  fieldid: 7,
                  fieldvalue: JSON.stringify(
                    convertToRaw(formData[i].label.getCurrentContent())
                  ),
                });
            }
            let obj = {};
            if (isNewSection) {
              let user = JSON.parse(localStorage.getItem("UserData"));
              obj = {
                chatbotid: chatbotId,
                userid: user?.id,
                ispublic: 0,
                sectionname: sectionName,
                sectionsubtitle: sectionSubtitle,
                title: formTitle,
                subtitle: formSubtitle,
                maketemplate: isTemplete,
                components: form,
              };
            } else {
              if (isEdit) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  formid: formId,
                  userid: user?.id,
                  chatbotid: chatbotId,
                  ispublic: 0,
                  title: formTitle,
                  subtitle: formSubtitle,
                  maketemplate: isTemplete,
                  deletedfieldids: deletedFieldIds,
                  deletedoptionids: deletedOptionIds,
                  components: forms,
                };
              } else if (isCandidateEdit) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  formid: formId,
                  userid: user?.id,
                  chatbotid: chatbotId,
                  ispublic: 0,
                  title: formTitle,
                  subtitle: formSubtitle,
                  deletedfieldids: deletedFieldIds,
                  deletedoptionids: deletedOptionIds,
                  components: forms,
                };
              } else if (isTemplateEdit) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  formid: formId,
                  userid: user?.id,
                  // ispublic: 0,
                  edit_template_type: "form",
                  template_name: templateTitle,
                  title: formTitle,
                  subtitle: formSubtitle,
                  deletedfieldids: deletedFieldIds,
                  deletedoptionids: deletedOptionIds,
                  components: forms,
                };
              } else if (isTemplateCopy) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  userid: user?.id,
                  // ispublic: 0,
                  template_name: templateTitle,
                  title: formTitle,
                  subtitle: formSubtitle,
                  components: forms,
                };
              } else if (isSectionTemplateEdit) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  userid: user?.id,
                  template_id: templateId,
                  formid: formId,
                  edit_template_type: "section",
                  title: formTitle,
                  subtitle: formSubtitle,
                  components: forms,
                  maketemplate: isTemplete,
                  deletedfieldids: deletedFieldIds,
                  deletedoptionids: deletedOptionIds,
                };
              } else if (isSectionTemplateCreate) {
                let user = JSON.parse(localStorage.getItem("UserData"));
                let tempData = JSON.parse(localStorage.getItem("Tempdata"));
                if (location?.state?.sectionname !== undefined) {
                  obj = {
                    templateid: tempData?.id,
                    userid: user?.id,
                    ispublic: 0,
                    sectionname: sectionName,
                    sectionsubtitle: sectionSubtitle,
                    title: formTitle,
                    subtitle: formSubtitle,
                    maketemplate: isTemplete,
                    components: form,
                  };
                } else {
                  obj = {
                    templateid: tempData?.id,
                    userid: user?.id,
                    sectionid: sectionId,
                    title: formTitle,
                    subtitle: formSubtitle,
                    maketemplate: isTemplete,
                    components: form,
                  };
                }
              } else {
                let user = JSON.parse(localStorage.getItem("UserData"));
                obj = {
                  chatbotid: chatbotId,
                  userid: user?.id,
                  sectionid: sectionId,
                  title: formTitle,
                  subtitle: formSubtitle,
                  maketemplate: isTemplete,
                  components: form,
                };
              }
            }
            console.log(obj);
            await ApiHelper.post(
              isEdit
                ? API.editForm
                : isCandidateEdit
                ? API.editCandidateForm
                : isTemplateEdit
                ? API.editTemplate
                : isTemplateCopy
                ? API.copyTemplate
                : isSectionTemplateEdit
                ? API.editTemplate
                : isSectionTemplateCreate
                ? API.createTempForm
                : API.createForm,
              obj
            )
              .then((resData) => {
                console.log("CreateForm", resData);
                if (isCandidateEdit && resData?.data?.success === true) {
                  navigate("/dashboard/candidates");
                  setLoader(false);
                } else if (
                  isSectionTemplateEdit &&
                  resData?.data?.success === true
                ) {
                  // navigate("/dashboard/onboarding/edit-onboarding-template");
                  toast("Form Saved Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setLoader(false);
                } else if (
                  isSectionTemplateCreate &&
                  resData?.data?.success === true
                ) {
                  navigate("/dashboard/onboarding/edit-onboarding-template");
                  toast("Form Saved Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setLoader(false);
                } else if (
                  (isTemplateEdit || isTemplateCopy) &&
                  resData?.data?.success === true
                ) {
                  // navigate("/dashboard/onboarding/templates");
                  toast("Form Saved Successfully", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setLoader(false);
                } else if (
                  (isTemplateEdit || isTemplateCopy) &&
                  resData?.data?.success === false
                ) {
                  toast("Form Name already exist!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setLoader(false);
                } else {
                  if (!isEdit && resData?.data?.success === true) {
                    setFormData([]);
                    setFormTitle("");
                    navigate("/dashboard/onboarding/edit-forms");
                    setLoader(false);
                  }
                  if (isEdit && resData?.data?.success === true) {
                    navigate("/dashboard/onboarding/edit-forms");
                    setLoader(false);
                  }
                }
              })
              .catch((err) => {
                setLoader(false);
                console.log(err);
              });
          }
        }, 1000);
      }
    }
  };

  //handles element drag and drop
  const onDragEnd = (data) => {
    const { draggableId, source, destination } = data;
    if (source && destination) {
      if (source.droppableId === "controls_droppable") {
        setLoader(true);
        setIsDrag(true);
        let newFormControl = {};
        if (draggableId === "heading") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            heading: EditorState.createEmpty(),
            subheading: EditorState.createEmpty(),
            field_type_id: 1,
            isRequired: false,
          };
        }
        if (draggableId === "paragraph") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            field_type_id: 2,
            isRequired: false,
          };
        }
        if (draggableId === "textfield") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            field_type_id: 6,
            isRequired: false,
          };
        }
        if (draggableId === "securefield") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            isRequired: false,
            field_type_id: 14,
          };
        }
        if (draggableId === "document") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            documentpath: "",
            isRequired: false,
            field_type_id: 11,
          };
        }
        if (draggableId === "multiplechoice") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            options:
              isEdit || isTemplateEdit || isSectionTemplateEdit
                ? [
                    { formfieldoptionid: "", option: "Yes" },
                    { formfieldoptionid: "", option: "Yes" },
                  ]
                : ["Yes", "No"],
            field_type_id: 9,
            isRequired: false,
          };
        }
        if (draggableId === "addimage") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            documentpath: "",
            isRequired: false,
            file_size: "small",
            file_alignment: "left",
            field_type_id: 3,
          };
        }
        if (draggableId === "addvideo") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            documentpath: "",
            isRequired: false,
            field_type_id: 5,
          };
        }
        if (draggableId === "eSignature") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label:
              "By selecting the “I agree” button, you agree to sign this document electronically and that your electronic signature is the legal equivalent of your manual/handwritten signature on this document. You further agree that your signature on this document is as valid as if you signed the document in writing.",
            showconsent: 0,
            isRequired: false,
            field_type_id: 5,
          };
        }
        if (draggableId === "uploadbutton") {
          newFormControl = {
            id: `${formData.length}`,
            fieldvalue: draggableId,
            label: EditorState.createEmpty(),
            isRequired: false,
            field_type_id: 7,
          };
        }
        const newFormData = [...formData];
        newFormData.splice(destination.index, 0, newFormControl);

        setFormData(newFormData);
        setTimeout(() => {
          setIsDrag(false);
          setLoader(false);
        }, 2000);
      }
      if (source.droppableId === "form_droppable") {
        setLoader(true);
        setIsDrag(true);
        if (source.index !== destination.index) {
          const newFormData = [...formData];
          let arr = [];
          const movedFormControl = newFormData.splice(source.index, 1)[0];
          newFormData.splice(destination.index, 0, movedFormControl);
          for (let i = 0; i < newFormData.length; i++) {
            if (newFormData[i].fieldvalue !== "eSignature") {
              if (newFormData[i].fieldvalue === "heading") {
                console.log(
                  i,
                  newFormData[i],
                  draftToHtml(
                    convertToRaw(newFormData[i].heading.getCurrentContent())
                  )
                );
              } else {
                console.log(
                  i,
                  newFormData[i],
                  draftToHtml(
                    convertToRaw(newFormData[i].label.getCurrentContent())
                  )
                );
              }
            }
            arr.push(newFormData[i]);
          }
          setFormData(arr);
          setTimeout(() => {
            setIsDrag(false);
            setLoader(false);
          }, 2000);
        } else {
          setIsDrag(false);
          setLoader(false);
        }
      }
    }
  };

  // set formData from templates
  const setForm = (item) => {
    setLoader(true);
    setFormTitle(item?.title);
    setFormSubtitle(item?.subtitle);
    let arr = item.fields;
    let array = [];
    for (let i = 0; i < arr?.length; i++) {
      if (arr[i].field_type_id === 1) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "heading",
          heading: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          field_type_id: arr[i].field_type_id,
        };

        array.push(obj);
      }
      if (arr[i].field_type_id === 2) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "paragraph",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 6) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "textfield",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 11) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "document",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          documentpath: arr[i].file_path,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 9) {
        let options = [];
        let optionobj = {};
        arr[i].field_options.map((item) => {
          options.push(item?.options);
        });
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "multiplechoice",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          options: options,
          formfieldid: arr[i].id,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 3) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "addimage",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          documentpath: arr[i].file_path,
          file_size: arr[i].file_size,
          file_alignment: arr[i].file_alignment,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 4) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "addvideo",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          documentpath: arr[i].file_path,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 5) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "eSignature",
          label: arr[i].field_value,
          formfieldid: arr[i].id,
          showconsent: arr[i].show_consent,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
      if (arr[i].field_type_id === 7) {
        let obj = {
          id: i + 1,
          isRequired: arr[i].is_required,
          fieldvalue: "uploadbutton",
          label: EditorState.createWithContent(
            convertFromRaw(JSON.parse(arr[i].field_value))
          ),
          formfieldid: arr[i].id,
          field_type_id: arr[i].field_type_id,
        };
        array.push(obj);
      }
    }

    setFormData(array);
    setIsTemplate(false);
    setLoader(false);
  };

  return (
    <div className="sidebar_open main-content" id="main">
      <div style={{ position: "fixed" }}></div>
      <div className="action-itms full-drp wrapAlign padNew cer-temps mt-2 ">
        <div className="wraper txtAlgn p-0 ">
          <div className="  col-lg-12   ">
            <div class="row  d-flex align-items-center">
              {isTemplateEdit ||
              isTemplateCopy ||
              (location.pathname === "/dashboard/onboarding/create-form" &&
                (chatbotId === undefined || chatbotId === null)) ? (
                <div class="team-member onbording-name-div col-md-6">
                  <div
                    className="form-floating creat-form-inputss "
                    style={{
                      border:
                        error === true &&
                        (templateTitle === "" || templateTitle === null)
                          ? "1px solid red"
                          : null,
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      id="signHereInput"
                      placeholder="Number of Days"
                      value={templateTitle}
                      onChange={(e) => {
                        setTemplateTitle(e.target.value);
                      }}
                    />
                    <label
                      htmlFor="signHereInput"
                      style={{ color: "#A4A4A4", fontSize: "14px" }}
                    >
                      Form Name
                    </label>
                  </div>
                  <p className="subHead top-texts-create">
                    Manage your custom form by choosing from the selection of
                    components below.
                  </p>
                </div>
              ) : (
                <div class="team-member onbording-name-div col-md-6">
                  <div className="hd-can create-form-wrp hegNew">
                    <h4 className="mainHead">Form Builder</h4>
                    <p className="subHead">
                      Build your custom form by choosing from the selection of
                      components below.
                    </p>
                  </div>
                </div>
              )}
              <div class="search serach-width-div col-md-6">
                {/* {console.log(
                  chatbotId,
                  isSectionTemplateEdit,
                  isSectionTemplateCreate,
                  isSectionTemplateCopy
                )}
                {isTemplateEdit && (
                  <button
                    className="Save top-save-bbtn eidt-temp-save-bttn"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                )} */}
                <div className="onb-actions fontSty edits-fil">
                  <a
                    className="btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      preview();
                    }}
                  >
                    {" "}
                    {/* <img src={Eye} alt="test" className="menu_icon" /> */}
                    Preview
                  </a>

                  {location.pathname === "/dashboard/onboarding/create-form" &&
                  (chatbotId === undefined || chatbotId == null) ? (
                    <button
                      className="Save"
                      onClick={() => {
                        createTemplate();
                      }}
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      className="Save"
                      onClick={() => {
                        if (
                          deletedFieldIds.length !== 0 ||
                          deletedOptionIds.length != 0
                        )
                          setShowAlert(true);
                        else handleSubmit();
                      }}
                    >
                      Save
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div
          id="tag2"
          className="accordion-collapse collapse wraper show "
          data-bs-parent="#tags"
        >
          <div className="wraper ">
            <div className="row create-grd">
              <div
                className="col-lg-3 col-md-3 padd-ajL d-none"
                style={{
                  display: isTemplateEdit || isTemplateCopy ? "none" : "block",
                  visibility: isTemplateEdit ? "hidden" : "visible",
                }}
                id="scrollLeftDiv"
              >
                <div className="left-fixed2">
                  <div
                    className="tempList create-comp-temp justify-content-center pl-0 pr-0 mb-3"
                    onClick={() => {
                      setIsTemplate(true);
                    }}
                  >
                    <a className="add-btn">
                      <img src={imp} alt="test" className="hd_icon-e" />
                      <p className="build-choose">Choose Form</p>
                    </a>
                  </div>
                  {sections.length !== 0 && (
                    <div className="sub-acc mb-4">
                      <h6>Form Section</h6>
                      <p className="my-3">
                        Use Form sections to organize your forms into groups
                        candidates can expand.{" "}
                      </p>
                      <select
                        className="form-select"
                        value={sectionId}
                        onChange={(e) => {
                          setSectionId(e.target.value);
                        }}
                      >
                        {sections?.map((item) => {
                          return (
                            <option value={item.id}>
                              {isSectionTemplateCreate
                                ? item?.template_section_name
                                : item.section_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  )}

                  {((location.pathname ===
                    "/dashboard/onboarding/create-form" &&
                    chatbotId !== undefined &&
                    chatbotId !== null) ||
                    isEdit ||
                    isSectionTemplateCreate ||
                    isSectionTemplateEdit) && (
                    <div className="sub-acc mb-4">
                      <div className="txtAlgn">
                        <h6>Template</h6>
                      </div>
                      <p className="my-4">
                        {" "}
                        Use this form as a reusable template?{" "}
                      </p>
                      <div className="d-flex">
                        <div className="form-check mx-3 ms-0">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="exampleRadios"
                            id="exampleRadios1"
                            value={true}
                            checked={isTemplete === true}
                            onChange={(e) => {
                              setIsTemplete(true);
                            }}
                          />
                          <label
                            className="form-check-label"
                            for="exampleRadios1"
                          >
                            Yes
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="exampleRadios"
                            id="exampleRadios2"
                            value={false}
                            checked={isTemplete === false}
                            onChange={(e) => {
                              setIsTemplete(false);
                            }}
                          />
                          <label class="form-check-label" for="exampleRadios2">
                            No
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                  {console.log(
                    chatbotId,
                    isCandidateEdit,
                    isSectionTemplateEdit,
                    isSectionTemplateCreate,
                    isSectionTemplateCopy
                  )}
                  {/* {(chatbotId === undefined || chatbotId === null) &&
                    (isCandidateEdit ||
                      isSectionTemplateEdit ||
                      isSectionTemplateCreate ||
                      isSectionTemplateCopy) && (
                      <div className="sub-acc mb-2 pLR-space">
                        <div className="txtAlgn mt-2">
                          <h6>Template</h6>
                        </div>
                        <p className="my-4">
                          Use this form as a <br /> reusable template?{" "}
                        </p>
                        <div className="d-flex">
                          <div className="form-check mx-3 ms-0">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios1"
                              checked
                            />
                            <label
                              className="form-check-label"
                              for="exampleRadios1"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="exampleRadios"
                              id="exampleRadios2"
                            />
                            <label
                              class="form-check-label"
                              for="exampleRadios2"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    )} */}

                  {location.pathname === "/dashboard/onboarding/create-form" &&
                  (chatbotId === undefined || chatbotId == null) ? (
                    <div className="save-btn mt-3">
                      <button
                        className="Save"
                        onClick={() => {
                          createTemplate();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    <div className="save-btn mb-3">
                      <button
                        className="Save"
                        onClick={() => {
                          if (
                            deletedFieldIds.length !== 0 ||
                            deletedOptionIds.length != 0
                          )
                            setShowAlert(true);
                          else handleSubmit();
                        }}
                      >
                        Save
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <DragDropContext onDragEnd={onDragEnd}>
                <>
                  <div
                    className={
                      isTemplateEdit || isTemplateCopy
                        ? "col-lg-8 col-md-5 px-3 padd-ajust"
                        : "col-lg-8 col-md-5 px-3 padd-ajust"
                    }
                  >
                    <div className="sub-acc blueborder newBorder wraper whiteBg mb-1">
                      <div className="wraper h-100 moves">
                        <div>
                          <Formik initialValues={initialValues}>
                            {({ submitForm, isSubmitting }) => (
                              <Droppable
                                droppableId="form_droppable"
                                type="controls"
                              >
                                {(provided, snapshot) => (
                                  <Form>
                                    <List
                                      className="trag-list-build"
                                      {...provided.droppableProps}
                                      ref={provided.innerRef}
                                    >
                                      <div>
                                        <section className="formSect mb-3">
                                          <form>
                                            <input
                                              className="inpTxt inp_titles blkCl"
                                              type="text"
                                              style={{
                                                border:
                                                  error === true &&
                                                  (formTitle?.trim() === "" ||
                                                    formTitle === null)
                                                    ? "1px solid red"
                                                    : null,
                                              }}
                                              placeholder="Enter Form Title..."
                                              value={formTitle}
                                              onChange={(e) => {
                                                setFormTitle(e.target.value);
                                              }}
                                            />
                                            <textarea
                                              className="inpTxt textArea  blkCl pt-0"
                                              placeholder="Enter Form Subtitle..."
                                              value={formSubtitle}
                                              onChange={(e) => {
                                                setFormSubtitle(e.target.value);
                                              }}
                                            ></textarea>
                                          </form>
                                        </section>
                                        {formData?.map((data, index) => (
                                          <div
                                            id={
                                              "formitem" +
                                              (index + 1).toString()
                                            }
                                          >
                                            <Draggable
                                              key={`form_draggable_${index}`}
                                              draggableId={`form_draggable_${index}`}
                                              index={index}
                                            >
                                              {(provided, snapshot) => (
                                                <div
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                >
                                                  <div
                                                    style={{
                                                      padding: "0px",
                                                      width: "100%",
                                                    }}
                                                    {...provided.dragHandleProps}
                                                  >
                                                    {getControl(
                                                      data.fieldvalue,
                                                      data.id,
                                                      data.label,
                                                      index
                                                    )}
                                                  </div>
                                                </div>
                                              )}
                                            </Draggable>
                                          </div>
                                        ))}
                                      </div>
                                      {provided.placeholder}
                                    </List>
                                  </Form>
                                )}
                              </Droppable>
                            )}
                          </Formik>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4" id="scrollRightDiv">
                    <div className="form-features-wrapper">
                      <div
                        className="tempList create-comp-temp justify-content-center pl-0 pr-0 mb-0"
                        onClick={() => {
                          setIsTemplate(true);
                        }}
                      >
                        <a className="add-btn">
                          <img src={imp} alt="test" className="hd_icon-e" />
                          <p className="build-choose">Choose Form</p>
                        </a>
                      </div>
                      <div className="form-features-xy-wrapper">
                        {sections.length !== 0 && (
                          <div className="sub-acc mb-4">
                            <h6>Form Section</h6>
                            <p className="my-3">
                              Use Form sections to organize your forms into
                              groups candidates can expand.{" "}
                            </p>
                            <select
                              className="form-select"
                              value={sectionId}
                              onChange={(e) => {
                                setSectionId(e.target.value);
                              }}
                            >
                              {sections?.map((item) => {
                                return (
                                  <option value={item.id}>
                                    {isSectionTemplateCreate
                                      ? item?.template_section_name
                                      : item.section_name}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        )}

                        {((location.pathname ===
                          "/dashboard/onboarding/create-form" &&
                          chatbotId !== undefined &&
                          chatbotId !== null) ||
                          isEdit ||
                          isSectionTemplateCreate ||
                          isSectionTemplateEdit) && (
                          <div className="sub-acc mb-4 d-flex flex-column justify-content-between">
                            <div className="hd-qwe">
                              <div className="txtAlgn">
                                <h6>Template</h6>
                              </div>
                              <p className="my-3">
                                {" "}
                                Use this form as a reusable template?{" "}
                              </p>
                            </div>
                            <div className="d-flex mb-2">
                              <div className="form-check mx-3 ms-0">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="exampleRadios"
                                  id="exampleRadios1"
                                  value={true}
                                  checked={isTemplete === true}
                                  onChange={(e) => {
                                    setIsTemplete(true);
                                  }}
                                />
                                <label
                                  className="form-check-label"
                                  for="exampleRadios1"
                                >
                                  Yes
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="exampleRadios"
                                  id="exampleRadios2"
                                  value={false}
                                  checked={isTemplete === false}
                                  onChange={(e) => {
                                    setIsTemplete(false);
                                  }}
                                />
                                <label
                                  class="form-check-label"
                                  for="exampleRadios2"
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        )}
                        {console.log(
                          chatbotId,
                          isCandidateEdit,
                          isSectionTemplateEdit,
                          isSectionTemplateCreate,
                          isSectionTemplateCopy
                        )}
                      </div>
                    </div>

                    <div className="sub-acc padSpace sticky-right">
                      <div className="txtAlgn pb-0">
                        <h6 className="form_titles padd-titles">
                          Form Elements
                        </h6>
                      </div>
                      <div className="fn-main mt-2 alignBox">
                        <Droppable
                          droppableId="controls_droppable"
                          type="controls"
                          isDropDisabled={true}
                        >
                          {(provided, snapshot) => (
                            <ul
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                            >
                              {controls.map((control, index) => (
                                <Draggable
                                  key={`control_draggable_${control.value}`}
                                  draggableId={control.value}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      className="boxDiv"
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <li key={control.value}>
                                        <div href="#" className="component">
                                          <img
                                            src={control.icon}
                                            alt="test"
                                            className="create-icon"
                                          />
                                          <h6>{control.label}</h6>
                                        </div>
                                      </li>
                                    </div>
                                  )}
                                </Draggable>
                              ))}

                              {provided.placeholder}
                            </ul>
                          )}
                        </Droppable>
                      </div>
                    </div>
                  </div>
                </>
              </DragDropContext>
            </div>
          </div>
        </div>
      </div>

      {/* popups */}
      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={showAlert}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Override Section
            </h2>
            <button
              onClick={() => {
                setShowAlert(false);
              }}
              className="modal-close"
            >
              {" "}
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-text1">
              Overriding the current onboarding form will result in the loss of
              any unsaved changes. Are you sure you want to proceed?
            </div>
            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button className="yes-btn rounded p-2" onClick={handleSubmit}>
                {" "}
                Yes
              </button>
              <p
                className="cancel-bttn"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setShowAlert(false);
                }}
              >
                {" "}
                Cancel
              </p>
            </div>
          </div>
        </Modal>
      </div>

      <Modal isOpen={isTemplate} className="tem-hide-dives">
        <div>
          <div className="modal-header mb-1">
            <h5 className="modal-title">Choose Form</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setIsTemplate(false);
                setSearchKey("");
              }}
            ></button>
          </div>
          <div className="create-comp-modal-body px-3 mb-2">
            <div className="serchField space m-0 col-lg-5">
              <img src={searchsmall} alt="test" className="serc_icon" />
              <input
                type="text"
                className="sercInp"
                placeholder="Search File Library..."
                onChange={(e) => {
                  setSearchKey(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="detail-tab-edit temp-space wraper m-0 p-3 pt-0 pb-0">
            <div className="create-comp-scroll m-0 scrlHe-tab scroll scroll1">
              {templates.length === 0 ? (
                <div className="col-lg-12 topnav-tab">
                  <a className="create-comp-popup-text-not-found">
                    <h6 className="create-comp-popup-text-heading-not-found">
                      No templates found
                    </h6>
                  </a>
                </div>
              ) : (
                templates.map((item) => {
                  return (
                    <div className="col-lg-12 topnav-tab">
                      <a
                        className={
                          selectedTemplate?.id === item?.id
                            ? "active create-comp-popup-text"
                            : "create-comp-popup-text"
                        }
                        onClick={() => {
                          setSelectedTemplate(item);
                        }}
                      >
                        <h6 className="create-comp-popup-text-heading">
                          {item?.template_name !== null
                            ? item?.template_name
                            : item?.title}
                        </h6>
                        <span
                          class="icon-trash"
                          onClick={() => {
                            setModalData({
                              itemId: item.id,
                              itemName: item.title,
                            });
                            setIsOpen(true);
                          }}
                        >
                          <img
                            src={trash}
                            alt="trash"
                            className="trash-icon-popup"
                          />
                        </span>
                      </a>
                    </div>
                  );
                })
              )}
            </div>
          </div>
          <div className="modal-footer footer-marg mt-0">
            <button
              type="button"
              className="btn btn-primary Cancel-pop"
              onClick={() => {
                setIsTemplate(false);
                setSearchKey("");
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary Add-pop mx-3"
              onClick={() => {
                setForm(selectedTemplate);
              }}
            >
              Add
            </button>
          </div>
        </div>
      </Modal>

      <div className="grid h-screen place-items-center ">
        <Modal
          isOpen={modalIsOpen}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-width dltPops">
            <h2 className="text-right text-xl modal-text">
              <img src={Alert} alt="copy" className="create-icon mb-0 me-2" />
              Delete Form
            </h2>
            <button
              className="modal-close"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              {" "}
              <img src={closex} alt="copy" className="create-icon m-0" />
            </button>
            <hr />
            <div className="modal-delect-text txtFonts pb-0">
              Are you sure you want to delete {modalData?.itemName} template?
            </div>

            <div className="q-btns my-3 d-flex justify-content-end modal-bttn">
              <button
                className="yes-btn rounded p-2"
                onClick={() => {
                  deleteFormTemplate(modalData.itemId);
                }}
              >
                {" "}
                Yes{" "}
              </button>
              <p
                className="cancel-bttn"
                onClick={() => {
                  setIsOpen(false);
                }}
              >
                {" "}
                Cancel{" "}
              </p>
            </div>
          </div>
        </Modal>
      </div>

      {loader && <Spinner />}
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <div className=" footer footer-bottom">
        <p className="p-0 m-0">&copy; Copyright ExtraHourz Inc. </p>
      </div>
    </div>
  );
};

export default CreateForm;
